import React from 'react'

import AddDiscountForm from './AddDiscountForm'
import AppliedDiscounts from './AppliedDiscounts'
import { DiscountProps } from './types'

const Discounts: React.FC<DiscountProps> = ({ location, className }) => {
  return (
    <>
      <AddDiscountForm location={location} className={className} />
      <AppliedDiscounts location={location} />
    </>
  )
}

export default Discounts
